const inputPlaceholder = () => {
    const form = document.querySelector(".js-placeholder");
    const acceptAll = document.getElementById("accept-all");
    let checkboxes;
    if (acceptAll) {
        checkboxes = document.querySelectorAll("[data-accept]");
    }
    if (form) {
        const inputsText = form.querySelectorAll("input[type='text']");
        for (var i = 0; i < inputsText.length; i++) {
            if (inputsText[i].value != "") {
                inputsText[i].parentElement.classList.add("filled");
            }
            else {
                inputsText[i].parentElement.classList.remove("filled");
            }
        }
    }
    if (acceptAll) {
        if (acceptAll.checked) {
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
            }
        }
        acceptAll.addEventListener("click", function(e){
            if (this.checked) {
                for (var i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = true;
                }
            }
            else {
                for (var i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = false;
                }
            }
        });
    }
    if (form) {
        form.addEventListener("change", function(e){
            if (e.target.type == "text") {
                if (e.target.value != "") {
                    e.target.parentElement.classList.add("filled");
                }
                else {
                    e.target.parentElement.classList.remove("filled");
                }
            }
            if (acceptAll && checkboxes.length > 0) {
                let allSelected = true;
                for (var i = 0; i < checkboxes.length; i++) {
                    if (!checkboxes[i].checked) {
                        allSelected = false;
                    }
                }
                if (allSelected) {
                    acceptAll.checked = true;
                }
                else {
                    acceptAll.checked = false;
                }
            }
        });
    }
}
export default inputPlaceholder;
